/**
 * Medical Cost Routes
 * legacy app: canActivate: [AuthGuard, VendorRoleGuard]
 * Uses ReactComponent with view: Views.MedicalCost
 */

import { RouteConfig, RouteMetadata } from '../../types';
import { lazy } from 'react';

const medicalCostRouteFrameStyles: React.CSSProperties = {
  width: '60rem',
  maxWidth: '100%',
  margin: '0 auto',
  boxSizing: 'border-box',
};

const MedicalCostRouteFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div style={medicalCostRouteFrameStyles}>{children}</div>
);

const MedicalCostPage = lazy(() =>
  import('./MedicalCostPage.tsx').then((m) => ({ default: m.MedicalCostPage }))
);

const MedicalCostRoute = () => (
  <MedicalCostRouteFrame>
    <MedicalCostPage />
  </MedicalCostRouteFrame>
);

const EXTERNAL_ACCESS_DENIED: Pick<RouteMetadata, 'externalAccess'> = {
  externalAccess: false,
};

export const medicalCostRoutes: RouteConfig[] = [
  {
    path: 'medical-cost/*',
    component: MedicalCostRoute,
    guards: ['auth', 'vendor'],
    data: {
      ...EXTERNAL_ACCESS_DENIED,
      title: 'Affordability Drivers',
      breadcrumb: 'Medical Cost',
      preload: false,
      delay: true,
      view: 'MedicalCost',
    },
  },
];

